<template>
  <div class="channel">
    <div class="header">
      <div class="title">{{ channelData.title }}</div>
      <div class="checkbox">
        <el-radio-group v-model="dateType" @change="selectDate">
          <el-radio-button v-for="date in dateOptions" :label="date.value" :key="date.value">{{ date.label }}</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div v-if="channelData.totalNum" class="total">总计：{{ channelData.totalNum || 0 }} 笔</div>
    <div v-if="channelData.totalNum" class="content">
      <div id="channel" style="height:360px;width:100%;"></div>
    </div>
    <div v-else class="no-data">暂无数据</div>
  </div>
</template>

<script>
/* eslint-disable */
import macarons from "../theme/macarons";

const echarts = require("echarts");
const channelMap = {
  aliPayNum: "阿里",
  wxPayNum: "微信",
  unionPayNum: "云闪付",
  posPayNum: "刷卡",
};

export default {
  props: {
    channelData: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      dateType: 1,
      dateOptions: [
        {
          value: 1,
          label: "今日"
        },
        {
          value: 2,
          label: "本周"
        },
        {
          value: 3,
          label: "本月"
        },
        {
          value: 4,
          label: "本年"
        }
      ]
    };
  },

  computed: {
    chartData() {
      let tmp = Object.assign({}, this.channelData);
      if (!tmp.totalNum) return [];
      delete tmp.totalNum;

      let initArr = tmp.payDataList.map(item => {
        return {
          value: item.nums,
          name: item.payType
        };
      });

      let filterArr = initArr.filter(item => item.value !== 0)
      return filterArr
    },

    options() {
      return {
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c}笔 ({d}%)"
        },
        series: [
          {
            name: "Channel From",
            type: "pie",
            radius: ["50%", "70%"],
            // minAngle: 10,
            avoidLabelOverlap: true,
            hoverAnimation: false,
            label: {
              normal: {
                show: true,
                // formatter: (obj) => {
                //   return obj.data.value !==0 ? '[{'+obj.data.name + '}] {' + obj.data.value + '}笔，{' + obj.percent + '}%'  : ''
                // },
                formatter: "[{b}] {c}笔，{d}%",
                textStyle: {
                  fontSize: "16",
                  color: "#999"
                }
              }
            },
            labelLine: {
              normal: {
                lineStyle: {
                  color: "rgba(0, 0, 0, 0.3)"
                },
                smooth: 0.2,
                length: 10,
                length2: 20,
              }
            },
            data: this.chartData
          }
        ]
      };
    }
  },

  watch: {
    channelData: {
      deep: true,
      handler() {
        if (this.chart) {
          console.log('yo');
          this.chart.clear()
        }
        this.drawChart();
      }
    }
  },

  mounted() {},

  methods: {
    drawChart() {
      if(this.channelData.totalNum) {
        setTimeout(() => {
          this.chart = echarts.init(document.getElementById("channel"), "macarons");
          this.chart.setOption(this.options);
        }, 50);
      }
    },

    selectDate(val) {
      this.$parent.$parent.$parent.getTransChannelData(val);
    }
  }
};
</script>

<style lang="scss" scoped>
.channel {
  position: relative;
  min-height: 100px;

  .header {
    box-sizing: border-box;
    position: relative;
    height: 42px;
    line-height: 42px;
    border-bottom: 1px solid #e4e7ed;

    .title {
      display: inline-block;
      font-size: 14px;
      font-weight: 500;
      color: #303133;
    }

    .checkbox {
      position: absolute;
      top: 0;
      right: 30px;
    }
  }

  .total {
    padding: 20px;
    text-align: right;
    font-size: 20px;
  }

  .no-data {
    position: absolute !important;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, -50%);
  }
}
</style>
